<template>
    <div class="row">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <div class="d-none d-lg-block col-lg-2"></div>
        <div class="col-12 col-lg-8">
            <h1>Area Management</h1>
            <!-- <p>This page allows you to manage individual users.</p> -->
            <div class="list-group">
                <div v-for="(a, idx) in areas" class="list-group-item">
                    <template v-if="editing == a.id">
                        <admin-areas-form 
                            :value="a"
                            @input="updated(idx, $event)"
                            @cancel="editing = -1"
                            >
                        </admin-areas-form>
                    </template>
                    <template v-else>
                        <div class="d-flex">
                            <div class="align-self-center me-3">
                                <admin-areas-delete-button :value="a" @input="deleted(a.id)"></admin-areas-delete-button>
                                <button type="button" class="btn btn-secondary btn-sm" @click="editing = a.id"><i class="fa-solid fa-pen-to-square"></i></button>
                            </div>
                            <div class="d-inline-block align-self-center flex-grow-1">
                                <h5 v-if="a.deleted_at" class="text-muted m-0">{{ a.name }}</h5>
                                <h5 v-else class="text-primary m-0">{{ a.name }}</h5>
                                <h6 class="text-secondary m-0">{{ a.state }}-{{ a.year }}</h6>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="list-group-item">
                    <admin-areas-form @input="created" ref="newArea"></admin-areas-form>
                </div>
            </div>
            <div class="mt-4">
                <home-button></home-button>
            </div>
        </div>

    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import AdminAreasForm from './AdminAreasForm';
    import AdminAreasDeleteButton from './AdminAreasDeleteButton.vue';
    import HomeButton from './HomeButton.vue';

    export default {
        components: { Loading, AdminAreasForm, HomeButton, AdminAreasDeleteButton }, 

        mounted() {
            this.isLoading = true;
            axios
                .get('/api/admin/areas')
                .then((response) => { 
                    this.areas = response.data;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        data() {
            return {
                isLoading: false,
                areas: [],
                editing: -1
            };
        },

        methods: {
            updated: function(index, event) {
                this.areas[index] = event;
                this.editing = -1;
            },

            created: function(event) {
                this.areas.push(event);
                this.$refs.newArea.clear();
            },

            deleted: function(id) {
                this.areas = this.areas.filter((area) => area.id != id);
            }
        }
    }
</script>